import React, { Fragment, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { IOrderDetails } from '../../models/product-detail';
import { IPatient } from '../../models/prosites';
import getAgreementError from '../../hooks/get-agreement-error';

interface Props {
    productId: string;
    cartItemTypeId: number;
    partNumber: string;
    maxQuantity: number;
    productUrl: string;
    addToCart: (order: IOrderDetails) => Promise<boolean>;
    selectedAgreement: string;
    country: string;
}

export const AddToCart: React.FC<Props> = ({
    productId,
    cartItemTypeId,
    partNumber,
    maxQuantity,
    productUrl,
    addToCart,
    selectedAgreement,
    country,
}) => {
    const intl = useIntl();
    const [quantity, setQuantity] = useState<number>(0);
    const [showAddedToCart, setShowAddedToCart] = useState<boolean>(false);
    const [showFailedToAddToCart, setShowFailedToAddToCart] =
        useState<boolean>(false);

    const handleChangeQty = (e: any) => {
        const num = e.target.value as number;
        if (num && num > 0) {
            setQuantity(Math.round(num > maxQuantity ? maxQuantity : num));
        } else {
            setQuantity(0);
        }

        setShowAddedToCart(false);
        setShowFailedToAddToCart(false);
    };

    const addProductToCart = async () => {
        if (!quantity) {
            setQuantity(1);
        }
        if (getAgreementError(selectedAgreement, country, cartItemTypeId))
            return;
        setShowAddedToCart(false);
        setShowFailedToAddToCart(false);

        const orderDetails = {
            itemGuid: productId,
            partNumber: partNumber,
            cartItemTypeId: cartItemTypeId,
            orderType: 'bulk',
            quantity: quantity ? quantity : 1,
            productUrl: productUrl,
            ...(selectedAgreement && {
                patient: {
                    agreement: true,
                    agreementType: selectedAgreement,
                } as IPatient,
            }),
        } as IOrderDetails;
        const success = await addToCart(orderDetails);
        if (success) {
            setShowAddedToCart(true);
        } else {
            setShowFailedToAddToCart(true);
        }
    };

    const handleKeyPressQty = (e: any) => {
        if (e.key === 'Enter') {
            addProductToCart();
        }
    };

    const handleAddToCart = async () => {
        addProductToCart();
    };

    return (
        <Fragment>
            <div
                className="row"
                style={{ float: 'right', paddingBottom: '20px' }}
            >
                <div
                    className="col-md-7"
                    style={{
                        padding: '8px 0px 0px 0px',
                    }}
                >
                    {showAddedToCart && (
                        <div
                            style={{
                                float: 'right',
                                paddingRight: '10px',
                                color: 'green',
                            }}
                        >
                            <span className="fa fa-check" />
                            <span style={{ paddingLeft: '5px' }}>
                                <FormattedMessage id="Added_to_Cart" />
                            </span>
                        </div>
                    )}
                    {showFailedToAddToCart && (
                        <div
                            style={{
                                float: 'right',
                                paddingRight: '10px',
                                color: 'red',
                            }}
                        >
                            <span className="fa fa-times-circle" />
                            <span style={{ paddingLeft: '5px' }}>
                                <FormattedMessage id="Failed_to_Add_to_Cart" />
                            </span>
                        </div>
                    )}
                </div>
                <div
                    className="col-md-5 input-group"
                    style={{ paddingTop: '0px' }}
                >
                    <input
                        type="number"
                        value={quantity && quantity > 0 ? quantity : ''}
                        placeholder={intl.formatMessage({
                            id: 'Quantity_Short',
                        })}
                        name={'addToCart-' + partNumber}
                        className="form-control"
                        onChange={handleChangeQty}
                        onKeyPress={handleKeyPressQty}
                        style={{ width: 'auto' }}
                    />
                    <span
                        className="input-group-addon"
                        style={{ padding: '0px' }}
                    >
                        <button
                            type="button"
                            style={{
                                borderStyle: 'solid',
                                borderColor: 'transparent',
                                backgroundColor: 'transparent',
                            }}
                            title={intl.formatMessage({
                                id: 'Add_to_Cart',
                            })}
                            onClick={handleAddToCart}
                        >
                            <i className="fas fa-cart-plus fa-lg" />
                        </button>
                    </span>
                </div>
            </div>
        </Fragment>
    );
};

export default AddToCart;
